import React, { useState } from "react";
import useAxiosInstance from "../../../../lib/useAxiosInstance";

/* ---------------------- MAIN LEGEND SECTION COMPONENT ---------------------- */

const LegendSection = ({
  configs,
  surveyId,
  legendData,
}) => {
  const [blockColors, setBlockColors] = useState({});

  const displayLegendData = React.useMemo(() => {
  const map = {};

  legendData?.forEach(item => {
    const key = item.text_value;

    if (!map[key]) {
      map[key] = {
        text_value: item.text_value,
        color: item.color,
        frequency: item.frequency || 0,
      };
    } else {
      map[key].frequency += item.frequency || 0;
    }
  });
  return Object.values(map);
}, [legendData]);

  return (
    <div className="rounded-xl bg-white/80 backdrop-blur-lg border p-2 shadow-md">
      {/* Legend Config Selector */}
        {configs.map((cfg) => (
          <h3
          className="text-sm font-semibold text-center text-[#123865] mb-3"
          title={cfg.heading || ""}
        >
          {cfg.heading || "Progress Chart"} Legend
        </h3>
        ))}

      {/* No Data */}
      {legendData?.length === 0 && (
        <div className="text-gray-500 text-sm">No legend data available.</div>
      )}

      {/* Legend List */}
      <div className="space-y-3">
        {displayLegendData?.map((item, index) => {
          const savedColor = blockColors[item.text_value] || item.color || "#000000";

          return (
            <div
              key={index}
              className="flex items-center justify-between p-2 border rounded-lg bg-white shadow-sm"
            >
              {/* Text Info */}
              <div>
                <div className="font-semibold text-black">{item.text_value}</div>
              </div>
              <div
                className="w-6 h-6 rounded-full border"
                style={{ backgroundColor: savedColor }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LegendSection;
